import React from "react";
import {
  Typography,
  Box,
  Paper,
  Grid,
  LinearProgress,
  IconButton,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useSearchParams } from "react-router-dom";

function ZoneDetails() {
  const [searchParams] = useSearchParams();
  const zone = searchParams.get("zone") || "zone1";

  // Sample static data for vehicles
  const vehicles = [
    { vNum: "MH12AB1234", timeLeft: { hours: 2, minutes: 45, seconds: 30 }, progress: 60 },
    { vNum: "KA05CD5678", timeLeft: { hours: 1, minutes: 15, seconds: 10 }, progress: 30 },
    { vNum: "DL03EF9012", timeLeft: { hours: 0, minutes: 45, seconds: 20 }, progress: 20 },
    { vNum: "TN07GH3456", timeLeft: { hours: 3, minutes: 30, seconds: 0 }, progress: 80 },
    { vNum: "GJ01IJ7890", timeLeft: { hours: 0, minutes: 10, seconds: 50 }, progress: 10 },
    { vNum: "UP14KL2345", timeLeft: { hours: 1, minutes: 55, seconds: 15 }, progress: 50 },
  ];

  // Map zone to display name
  const zoneNames = {
    zone1: "Damber Chowk",
    zone2: "10th Mile",
    zone3: "9th Mile",
    zone4: "CK Chowk",
  };

  // Sample Google Maps URL (replace with actual coordinates later)
  const googleMapsUrl = "https://www.google.com/maps?q=19.0760,72.8777";

  return (
    <Box
      sx={{
        backgroundColor: "#e6f7ff",
        minHeight: "100vh",
        p: 2,
        fontFamily: "sans-serif",
      }}
    >
      <div className="header">
        <img src="/logo.png" alt="Logo" className="logo" />
        <div className="heading-text">
          <br />
          <h1 className="title">Smart Parking App</h1>
          <p className="caption">"Empowering Digital India .."</p>
        </div>
      </div>
      <br />
      <Paper
        elevation={3}
        sx={{
          maxWidth: 600,
          margin: "auto",
          p: 4,
          borderRadius: 3,
          backgroundColor: "#fff",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: "700" }}>
            {zoneNames[zone] || "Unknown Zone"}
          </Typography>
          <IconButton
            component="a"
            href={googleMapsUrl}
            target="_blank"
            sx={{ ml: 1 }}
          >
            <LocationOnIcon sx={{ color: "#5b9bd5" }} />
          </IconButton>
          <Typography variant="body2" sx={{ ml: 1, color: "#5b9bd5" }}>
            0.8 Km
          </Typography>
        </Box>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "medium" }}>
          Parked Vehicles
        </Typography>

        <Grid container spacing={2} direction="column">
          {vehicles.map((vehicle, index) => (
            <Grid item xs={12} key={index}>
      <hr />

              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                  {vehicle.vNum}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Expires in: {vehicle.timeLeft.hours}h {vehicle.timeLeft.minutes}m {vehicle.timeLeft.seconds}s
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={vehicle.progress}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  backgroundColor: "#4caf50",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "#ff0000",
                    transform: "scaleX(-1)",
                  },
                  transform: "rotate(180deg)",
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Paper><br />
      <Typography variant="h6" style={{ color: 'grey', fontWeight: 600, textAlign: 'center'}}>(2) Parking Slots Left</Typography>
    </Box>
  );
}

export default ZoneDetails;